import(/* webpackMode: "eager" */ "/home/runner/work/customer-frontend/customer-frontend/src/app/error.tsx");
